import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";

export default [
  {
    prop: "CustomerCode",
    name: "CustomerCode",
    label: "Código de Cliente",
    width: 200,
    sortable: true
  },
  {
    prop: "CustomerName",
    name: "CustomerName",
    label: "Nombre del Cliente",
    width: 500,
    sortable: true
  },
  {
    prop: "AnniversaryDate",
    name: "AnniversaryDate",
    label: "Aniversario",
    formatter: DatetimeFormatter,
    width: 200,
    sortable: true
  },
  {
    prop: "EMail",
    name: "EMail",
    label: "E-Mail",
    minWidth: 300,
    sortable: true
  },
  {
    prop: "PhoneNumber",
    name: "PhoneNumber",
    label: "Teléfono",
    minWidth: 130,
    sortable: true
  }
];
